import project1 from "../assets/project1.jpg"
import project2 from "../assets/coinsgrate2.jpg";
import project3 from "../assets/fortuna-1.jpg";
import project4 from "../assets/project4.jpg";
import project5 from "../assets/project5.jpg";
import project6 from "../assets/project6.jpg";
import project7 from "../assets/project7.jpg";
import project8 from "../assets/project8.jpg";
import project9 from "../assets/project9.jpg";

import { 
    FaCss3Alt,FaHtml5, FaJava,
    FaPython, FaNodeJs, FaReact,
    FaVuejs
} from "react-icons/fa";
import { 
    SiFirebase, 
    SiJavascript,
    SiMongodb, 
    SiTypescript,
} from "react-icons/si";

const experience = [
    {
        id:1,
        company: "Blinx",
        title: "Frontend Developer",
        start_date: "Nov 22",
        end_date: "Present",
        roles: [
            "Design and implement user interfaces based on wireframes and visual designs.",
            "Collaborate with backend developers to integrate frontend interfaces with server-side APIs.",
            "Debug and fix bugs during development or based on user feedback",
            "Communicate effectively within the team and provide updates on progress."
        ]
    },
    {
        id:2,
        company: "Coralstone Capital",
        title: "Frontend Developer",
        start_date: "April 22",
        end_date: "August 22",
        roles: [
            "Design and implement user interfaces based on wireframes and visual designs.",
            "Collaborate with backend developers to integrate frontend interfaces with server-side APIs.",
            "Debug and fix bugs during development or based on user feedback",
            "Communicate effectively within the team and provide updates on progress."
        ]
    },
    {
        id:4,
        company: "Headies Award",
        title: "Frontend Developer",
        start_date: "March 23",
        end_date: "April 23",
        roles: [
            "Design and implement user interfaces based on wireframes and visual designs.",
            "Collaborate with backend developers to integrate frontend interfaces with server-side APIs.",
            "Debug and fix bugs during development or based on user feedback",
            "Communicate effectively within the team and provide updates on progress."
        ]
    }
];

const projects = [
    {
        id: 1,
        title: "FortunaNFT",
        img_url: project1,
        description: "FortunaNFT is a Lottery website for NFT hodlers, users can connect their wallet, buy a lottery ticket and wait for THE DRAW",
        built_with: [ "ReactJs" ],
        website_link: "https://divinedraw.com",
        github_link: "https://github.com/ea10-lite/fortuna-wheels.git",
    },
    {
        id: 2,
        title: "Coinsgrate",
        img_url: project2,
        description: "Coinsgrate is a user-friendly website that provides real-time updates, comprehensive charts, and insightful analysis on a wide range of digital currencies. ",
        built_with: [ "NextJs" ],
        website_link: "https://coinsgrate.netlify.app",
        github_link: "https://github.com/ea10-lite/crypto-tracker.git",
    },
    {
        id: 9,
        title: "Admin Dashboard",
        img_url: project9,
        description: "",
        built_with: ["MERN Stack", "MongoDB", "Express", "ReactJS", "NodeJs"],
        website_link: "https://merchant-z.netlify.app/",
        github_link: "https://github.com/EA10-lite/storex-client.git/",
    },
    {
        id: 4,
        title: "CineView",
        img_url: project4,
        description: "CineView is your one-stop destination for all things movies. Discover the hottest releases, explore popular films, and indulge in the excitement of upcoming blockbusters—all in one place.",
        built_with: [ "ReactJs" ],
        website_link: "https://movie-app-ea10.netlify.app",
        github_link: "https://github.com/ea10-lite/movie-app-ea10.git",
    },
    {
        id: 5,
        title: "Soccer App",
        img_url: project5,
        description: "LiveSoccerNet is the go-to website for all soccer enthusiasts. Whether you're a die-hard fan, a casual follower, or just curious about the beautiful game, our platform is designed to bring you the thrill and excitement of live soccer matches like never before.",
        built_with: [ "ReactJS" ],
        website_link: "https://soccer-app-ea10.netlify.app",
        github_link: "https://github.com/ea10-lite/soccer-app.git",
    },
    {
        id: 6,
        title: "Shareme",
        img_url: project6,
        description: "Shareme is a social media sharing platform just like pinterest.With Shareme, sharing your favorite moments, discoveries, and experiences has never been easier or more engaging.",
        built_with: ["ReatcJS", "TailwindCSS", "MasonryGrid"],
        website_link: "https://shareme-ea10.netlify.app/",
    },
    {
        id: 7,
        title: "Hangman",
        img_url: project7,
        description: "Hangman is a guessing game for two or more players (Machine and Human). The Machine Randomly Picks a word from a list of hard coded words, and the human player tries to guess it by suggesting letters ..",
        built_with: [ "HTML", "CSS", "Javascript" ],
        website_link: "https://ea10-hangman.netlify.app/",
        github_link: "https://github.com/EA10-lite/Hangman.git/",
    },
    {
        id: 8,
        title: "GPT-3",
        img_url: project8,
        description: "GPT-3 is a landing page website for GPT3 AI Launch.",
        built_with: [ "ReactJS" ],
        website_link: "https://ea10-gpt3.netlify.app/",
        github_link: "https://github.com/EA10-lite/gpt3.git/",
    },
    {
        id: 3,
        title: "Instagram Clone",
        img_url: project3,
        description: "Instagram clone is a dynamic social media platform that allows you to capture and share moments with your friends and followers. Just like Instagram.",
        built_with: ["MERN Stack", "MongoDB", "Express", "ReactJS", "NodeJs"],
        website_link: "https://coinsgrate.netlify.app",
        github_link: "https://github.com/ea10-lite/instagram-clone.git",
    },
]


const skills = [
    { title: "HTML", Icon: FaHtml5, color: "#DD4B25" },
    { title: "CSS", Icon: FaCss3Alt, color: "#254BDD" },
    { title: "Javascript", Icon: SiJavascript, color: "#EDD718", bg: "#fff" },
    { title: "Typescript", Icon: SiTypescript, color: "#2f74C0", bg: "#fff" },
    { title: "ReactJS", Icon: FaReact, color: "#5ED3FE" },
    { title: "VueJS", Icon: FaVuejs, color: "#3FB27F" },
    { title: "NextJS", color: "#5ED3FE" },
    { title: "NodeJS", Icon: FaNodeJs, color: "#73AB63"},
    { title: "Python", Icon: FaPython, color: "#356C9B" },
    { title: "Java", Icon: FaJava, color: "#356C9B" },
    { title: "Firebase", Icon: SiFirebase, color: "#FFCC30" },
    { title: "Mongodb", Icon: SiMongodb, color: "#5DB050" },
]

const profession = [
    { 
        id: 1, 
        title: "Frontend Developer", 
        description: "I specialize in creating engaging and responsive user interfaces. I am proficient in <span> HTML </span>, <span> CSS </span>, and <span> JavaScript </span>, and have experience with modern frameworks such as <span> React </span> and <span> Vue.js </span>. I am skilled in building <span> interactive web applications </span>, implementing <span> UI/UX designs </span>, and <span> optimizing websites </span> for performance.",
    },


    { 
        id: 2, 
        title: "Backend Developer", 
        description: "I specialize in designing and implementing robust <span> server-side </span> applications. My preferred tools include languages like <span> Node.js </span>, frameworks like <span> Express.js </span>, and databases like <span> PostgreSQL </span> or <span> MongoDB </span>."
    },

    { 
        id: 3, title: "Python Developer", description: "I am proficient in writing clean and efficient <span> Python </span> code. I have experience in core Python concepts such as <span> data types </span>, <span> control flow </span>, <span> functions </span>, and <span> object-oriented programming </span>. I am familiar with popular Python libraries and frameworks like <span> NumPy </span>, <span> Pandas </span>, <span> Matplotlib </span>." },

    { id: 4, title: "Java Developer", description: " I have a solid understanding of core Java concepts and principles. I am proficient in <span> writing clean </span> and <span> structured Java </span> code, utilizing <span> object-oriented programming </span> principles. I am eager to continue expanding my Java skills and take on new challenges in <span> software development </span>." },
]

const data = {
    experience,
    projects,
    profession,
    skills,
}

export default data;